export default __webpack_public_path__ + "static/media/clear.inline.7efc883b.svg";